import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { useAuth } from "../context/authcontext";

//views - main
import Main from '../viewsxz/main';
import UsersView from "../viewsxz/users-view";
import EventsListWW from "../viewsxz/events-list";
import EventsViewWW from "../viewsxz/events-view";

import TokensViewWW from "../viewsxz/tokens-view";

// views - home
import HomeUser from "../viewsxx/home-indx";
import HomeBusiness from "../viewsxx/home-bznx";

// views - events
import Events from "../viewsev/events";
import EventsCreate from "../viewsev/events-create";
import EventsView from "../viewsev/events-view";

//view - tokens
import Tokens from "../viewsev/tokens";
import TokensView from "../viewsev/tokens-view";
import WorkCreate from "../viewsev/work-create";
import AcademicCreate from "../viewsev/academic-create";

// views - contacts
import Contacts from "../viewsxc/contacts";
import ContactsAdd from "../viewsxc/contacts-add";

// views - accounts
import AccountsLink from "../viewsxt/accounts-link";

// views - transfers
import Transfers from "../viewsxt/transfers";
import TransfersCredit from "../viewsxt/transfers-credit";
import TransfersDebit from "../viewsxt/transfers-debit";

import Poaps from "../viewsxt/poap";
import PoapsCreate from "../viewsxt/poap-create";

import Credits from "../viewsxt/credits";

// views - settings
import Settings from "../viewsxs/settings";

// view- xumm
import Xumm from "../viewsxz/xumm";

// views - auth - onbd
import AuthMobileFirebase from "../viewsxa/auth-mobile-firebase";
import AuthMailFirebase from "../viewsxa/auth-mail-firebase";
import AuthMailCheckFirebase from "../viewsxa/auth-mail-check";
import AuthNext from "../viewsxa/auth-next";
import AuthSessionX from "../viewsxa/auth-session-x";

import OnboardUser from "../viewsxb/onboard-user";
import OnboardAccount from "../viewsxb/onboard-account";
import OnboardBusiness from "../viewsxb/onboard-business";


const routes = [

  { path:'/', component: Main, auth:false },
  { path:'/e', component: EventsListWW, auth:false },
  { path:'/e/:id', component: EventsViewWW, auth:false },
  { path:'/u/:id', component: UsersView, auth:false },
  { path:'/x', component: Xumm, auth:false },

  { path:'/c/:id', component: TokensViewWW, auth:false },

  { path:'/in/home', component: HomeUser, auth:false },
  { path:'/bz/home', component: HomeBusiness, auth:false },

  { path:'/in/events', component: Events, auth:false },
  { path:'/in/events/view/:id', component: EventsView, auth:false },
  { path:'/in/events/create', component: EventsCreate, auth:false },

  { path:'/in/tokens', component: Tokens, auth:false },
  { path:'/in/tokens/view/:id', component: TokensView, auth:false },
  { path:'/in/work/create', component: WorkCreate, auth:false },
  { path:'/in/academic/create', component: AcademicCreate, auth:false },

  { path:'/in/credits', component: Credits, auth:false },

  { path:'/in/contacts', component: Contacts, auth:false },
  { path:'/in/contacts/add', component: ContactsAdd, auth:false },
  
  { path:'/bz/contacts', component: Contacts, auth:false },
  { path:'/bz/contacts/add', component: ContactsAdd, auth:false },

  { path:'/in/accounts/link', component: AccountsLink, auth:false },

  { path:'/in/transfers', component: Transfers, auth:false },
  { path:'/in/transfers/debit', component: TransfersDebit, auth:false },
  { path:'/in/transfers/credit', component: TransfersCredit, auth:false },

  { path:'/in/poap', component: Poaps, auth:false },
  { path:'/in/poap/send', component: PoapsCreate, auth:false },
  { path:'/bz/transfers', component: Transfers, auth:false },

  { path:'/in/settings', component: Settings, auth:false },
  { path:'/bz/settings', component: Settings, auth:false },

  { path:'/account/mobile', component: AuthMobileFirebase, auth:false },
  { path:'/account/mail', component: AuthMailFirebase, auth:false },
  { path:'/account/mail/auth', component: AuthMailCheckFirebase, auth:false },
  { path:'/account/next', component: AuthNext, auth:true },
  { path:'/account/sessionx', component: AuthSessionX, auth:true },

  { path:'/onboard/user', component: OnboardUser, auth:true },
  { path:'/onboard/account', component: OnboardAccount, auth:true }

]

const PrivateRoute = (props) => {
  const location = useLocation();
  
  const { user } = useAuth();
  return user 
  ? ( <Route { ...props } /> ) 
  : ( <Redirect to={{ pathname: "/", state: { from: location } }} /> )
};

export default function Routes() {

  return (
    <Switch>
      {routes.map ((item,i)=>(item.auth
      ? <PrivateRoute
          key={i}
          path={item.path}
          component={item.component}
          exact
        />
      : <Route
          key={i}
          path={item.path}
          component={item.component}
          exact
        />
      ))}
    </Switch>
  );
}